package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class UpdateMerchantLocationResponseModel(
    val locationId: Long? = null
) : BaseResponseModel()
